import { useTranslation } from "react-i18next";
import { Flex, Spin } from "antd";
import styles from "@/features/payment-form/ui/PaymentForm/styles.module.scss";
import { useCheckPayment } from "@/features/payment-form/model/hooks";
import { AppButton } from "@/shared/Components";

export const CheckPayment = () => {
  const { t } = useTranslation();
  const { state, methods } = useCheckPayment();

  const { paymentCancelled } = state;
  const { handleTryAgain, handleGoBack } = methods;

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>
        {t(`registrationPage.checkPayment.${paymentCancelled ? "paymentCancelled" : "title"}`)}
      </h1>
      {!paymentCancelled && <Spin />}
      {paymentCancelled && (
        <Flex>
          <AppButton type="link" onClick={handleGoBack}>
            {t("registrationPage.checkPayment.goBack")}
          </AppButton>
          <AppButton type="primary" onClick={handleTryAgain}>
            {t("registrationPage.checkPayment.tryAgain")}
          </AppButton>
        </Flex>
      )}
    </div>
  );
};
